import {
	Component,
	Inject,
	OnInit,
	Optional,
	ChangeDetectionStrategy,
} from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogRef,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import {
	MatCard,
	MatCardHeader,
	MatCardTitle,
	MatCardContent,
} from '@angular/material/card';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-rapid-result-modal',
	templateUrl: './rapid-result-modal.component.html',
	styleUrls: ['./rapid-result-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		MatCard,
		MatCardHeader,
		MatCardTitle,
		MatCardContent,
		NgIf,
		MatDialogActions,
		MatButton,
		MatDialogClose,
	],
})
export class RapidResultModalComponent implements OnInit {
	protected title: string = '';
	protected approvalMessage: string = '';
	protected mortgageBalance: string = '';
	protected estimatedValue: string = '';
	protected ltv: number = 0;
	protected rapidScoreStatus: string = '';
	protected rapidStatus: string = '';
	protected rapidStage: string = '';

	zoho_app_id: any;

	constructor(
		private readonly apiService: LegacyApiService,
		public dialogRef: MatDialogRef<RapidResultModalComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any
	) {
		dialogRef.disableClose = true;
	}

	public ngOnInit(): void {
		const usdFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		});

		switch (this.data.rapid_status) {
			case 'Rapid Approved':
				this.title = 'Rapid Approved';
				this.approvalMessage = `File has been ${this.data.approvalMessage}`;
				break;
			case 'Conditionally Approved':
				this.title = 'Conditionally Approved';
				this.approvalMessage = `File has been ${this.data.approvalMessage}`;
				this.mortgageBalance = usdFormatter.format(
					this.data.result.mortgageData?.mortgage_balance
				);
				this.estimatedValue = usdFormatter.format(
					this.data.result.mortgageData?.estimated_value
				);
				break;
			case 'In Progress':
				this.title = `In Progress review for ${usdFormatter.format(this.data.receivedRapidData.client.loan_amount)}`;
				break;
			default:
				break;
		}
		this.ltv = this.data.result.mortgageData?.ltv;
		this.rapidScoreStatus = this.data.result.rapid_score_status;
		this.rapidStatus = this.data.result.rapid_status;
		this.rapidStage = this.data.result.rapid_stage;
	}

	protected onClose(): void {
		this.dialogRef.close(false);
	}
}
